<div class="content">
    <h1 class="page-title">Cursos</h1>
    <p>
        <strong>Veja abaixo mais detalhes sobre estes cursos e os procedimentos para inscrição:</strong>
    </p>

    <h4>1. Módulo A</h4>

    <p>
        <strong>Conteúdo</strong>: Play and Stay (exercícios e jogos), Ensino para Iniciantes, Exercícios de
        desenvolvimento motor, Introdução dos Golpes Básicos, Desenvolvimento Físico para Crianças e Jovens, Princípios
        Táticos do Jogo de Tênis, Psicologia para Crianças e O Papel do Professor
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica e prática.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>2. Módulo B</h4>

    <p>
        <strong>Conteúdo</strong>: Estrutura da aula individual, Golpes Básicos (Empunhaduras, Preparação, Terminação e
        posições de pernas), Utilização dos Lançamentos e Cestos de bolas, Tática e Estratégia para o jogo de Simples,
        Técnicas de Correção e Melhoras, Os efeitos e trajetórias da bola, Regras de Tênis e Organização de torneios.
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica, prática, nível de jogo e lançamentos.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>3. Módulo C</h4>

    <p>
        <strong>Conteúdo</strong>: Aula em Grupo com Progressões dos Golpes de Fundo/ Voleios/ Saque/Devolução,
        Organização e Distribuição de Alunos na Aula em Grupo, Aula em grupo com jogadores de diferentes níveis, Atenção
        individual na aula em grupo, Liderança e comunicação na aula em grupo, Preparação Física, ITN ( Número
        Internacional de Tênis),Tênis em Cadeira de Rodas,Tênis para Deficientes Intelectuais, Equipamentos de Tênis.
    </p>

    <p>
        - Duração: 25 horas&nbsp;<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica e prática.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>4. Módulo D</h4>

    <p>
        <strong>Conteúdo</strong>: A Metodologia do Ensino, A Comunicação com o Jogador, Etapas do Processo de
        Aprendizagem, Como Jogar Contra os Diferentes Estilos de Jogo, Exercícios Táticos de Simples e Duplas, A
        Antecipação no Jogo de Tênis, Jogo de Porcentagens, O "Momento" do Jogo, Análise Tática das Partidas.
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica e prática.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>5. Módulo E</h4>

    <p>
        <strong>Conteúdo</strong>: A Biomecânica no tênis, Aplicações práticas da biomecânica, Técnicas avançadas para
        execução de golpes, Diagnóstico e correções técnicas, A movimentação em quadra, Filmagens em Super Slow Motion,
        Análise de Vídeos dos Melhores Jogadores da Atualidade.
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica e prática.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>6. Módulo F</h4>

    <p>
        <strong>Conteúdo</strong>: A planificação da carreira do jogador, o desenvolvimento do jogador nas diferentes
        etapas e idades, como fazer a análise do jogador, o estabelecimento de objetivos, a planificação do treinamento,
        periodização, a sessão de treinamento e estruturação de exercícios.
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica e prática.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>7. Módulo G</h4>

    <p>
        <strong>Conteúdo</strong>: A preparação física no tênis (demanda energética do tênis, potência, agilidade,
        treinamento aeróbico para tenista), o acompanhamento dos jogadores em torneios, o treinamento de jogadoras, a
        nutrição para o tenista, prevenção de lesões e o treinamento mental (concentração, motivação, controle
        emocional, auto confiança e rotinas).
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>8. Módulo Avançado</h4>

    <p>
        - Se trata de um curso dirigido a treinadores interessados em trabalhar com jogadores de competição.<br />
        - &nbsp;É composto de 5 Módulos de 25 horas cada um e correspondem ao Nível 3 da ITF.<br />
        - Os Módulos são independentes e podem ser realizados separadamente<br />
        - Divisão dos Módulos: Tática/Metodologia; Biomecânica; Planificação/ Desenvolvimento; Preparação Física e
        Psicologia.<br />
        - Nos cursos de psicologia e preparação física serão aceitos profissionais especializados nestas áreas.<br />
        - Como pré-requisito é necessário que o treinador tenha sido aprovado nos Módulos ABC ou Nível 1. Além disso,
        para cada Módulo haverão pré-requisitos específicos e um limite de 25 participantes.
    </p>

    <p>
        - Duração: 25 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica e prática.<br />
        - Pontos no SNGP: 20<br />
        - Valor: R$ 320,00 (filiados) e R$ 430,00 (não filiados)
    </p>

    <h4>8.1 Tática e Metodologia</h4>

    <p>
        <strong>Conteúdo</strong>: Introdução a táticas avançadas, princípios táticos do tênis de alto nível, estilos de
        jogo tático do tênis moderno, tática de jogo no tênis feminino, táticas em diferentes superfícies, análise e
        estatística de partidas, tática de duplas para jogadores avançados, metodologia de treinamento para o tênis
        avançado, aprendizagem das habilidades motoras para o alto nível.
    </p>

    <h4>8.2 Biomecânica</h4>

    <p>
        <strong>Conteúdo</strong>: Biomecânica e técnicas avançadas, a aceleração da cabeça da raquete, velocidade
        linear e angular, biomecânica do movimento em quadra, carga e produção do golpe, análise de produção dos golpes:
        quantitativo/qualitativo, modelos de desempenho biomecânico, atividade muscular e sua importância.
    </p>

    <h4>8.3 Planificação/Desenvolvimento do Tênis</h4>

    <p>
        <strong>Conteúdo</strong>: Plano de desenvolvimento do jogador, destrezas profissionais para treinadores
        avançados: liderança, administração, organização, desenvolvimento profissional, marketing no tênis, comunicação
        e informática, criação e implantação de um plano para o desenvolvimento do tênis, comercialização e promoção do
        tênis, plano de desenvolvimento de recursos, diferentes programas de tênis, calendário de torneios.
    </p>

    <h4>8.4 Preparação Física</h4>

    <p>
        <strong>Conteúdo</strong>: Avaliação fisiológica do tenista, desenvolvimento atlético a longo prazo, princípios
        do treinamento, coordenação, flexibilidade, resistência aeróbia/anaeróbica, desenvolvimento da força, potência
        no tênis, velocidade e agilidade, mecânica do movimento, trabalho durante os torneios, recuperação.
    </p>

    <h4>8.5 Psicologia</h4>

    <p>
        <strong>Conteúdo</strong>: Treinamento mental para jogadores avançados, fixação de metas, destrezas psicológicas
        para jogadores de alto nível, motivação, &nbsp;técnicas de concentração, controle emocional, controle de
        pensamentos, rotinas psicológicas, desempenho psicológico em competição, imagens/visualização, desenvolvimento
        psicológico e planificação.
    </p>

    <h4>9. Play and Stay</h4>

    <p>
        <strong>Conteúdo</strong>:&nbsp;Apresentação do Programa Play and Stay, Como utilizar os diferentes tipos de
        bolas e tamanhos de quadra, Como tornar o tênis fácil, divertido e saudável, Trabalho técnico/tático com
        jogadores iniciantes, Golpes básicos – ensino por progressões, Ensino através do jogo, Exercícios de
        desenvolvimento motor e Tênis e seu benefício para a saúde.
    </p>

    <p>
        - Duração: 8 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: não há.<br />
        - Pontos no SNGP: 6<br />
        - Valor: R$ 200,00&nbsp;(filiados) e R$250,00&nbsp;(não filiados)
    </p>

    <p>
        <strong>10. Curso para professores e administradores de clubes e academias</strong><br />
        "Produtos e estratégias para crescimento do seu trabalho"
    </p>

    <p>
        <strong>Objetivo</strong>: Apresentar para os professores e administradores de clubes e academias, produtos e
        estratégias para a conquista de novos alunos e a consolidação dos jogadores atuais, proporcionando um maior
        ganho aos professores e instituições.
    </p>

    <p>
        <strong>Conteúdo</strong>: Por que as pessoas vem jogar tênis e param de jogar tênis?, O Play and Stay no Brasil
        e no mundo, Dinâmicas e jogos em grupo, Habilidades necessárias para um professor trabalhar com<strong
        > </strong>a iniciação, O tênis e seus benefícios para a saúde, Tênis um esporte para todos, ITN (Número
        Internacional do Tênis), Circuitos regionais e nacionais, Diferentes formatos de competição, Relação
        professor/administrador &nbsp;- Trabalho em equipe, O bom funcionamento de uma escola de tênis, Ações de
        promoção do tênis, Marketing do tênis.
    </p>

    <p>
        - Duração: 15 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: não há.<br />
        - Pontos no SNGP: 9<br />
        - Valor: Professores: R$ 270,00&nbsp;(filiados) e R$ 325,00&nbsp;(não filiados)
    </p>

    <h4>11. Tennis Xpress</h4>

    <p>
        <strong>Conteúdo</strong>: A introdução do tênis para adultos iniciantes, apresentação do curso Tennis Xpress de
        9 horas, o uso das diferentes progressões de bola e quadra, organização da aula em grupo, o trabalho com alunos
        de diferentes níveis, organização de jogos com adultos, iniciativas para os alunos darem &nbsp;continuidade no
        tênis.&nbsp;
    </p>

    <p>
        - Duração: 7 horas<br />
        - Horário: das 09:00 às 17:00 hrs.<br />
        - Avaliação: não há<br />
        - Pontos no SNGP: 6<br />
        - Valor: R$ 200,00 (filiados) e R$ 250,00&nbsp;(não filiados)
    </p>

    <h4>12. Módulo Escolar</h4>

    <p>
        <strong>Conteúdo</strong>: Justificativa do programa, Por que o tênis nas escolas, Filosofia do programa,
        Material necessário para a implantação, Metodologia de ensino, Mini-tênis, Aspectos pedagógicos, Aspectos
        administrativos e jurídicos, Principais obstáculos à implantação e como superá-los, Abordagem à célula
        receptora: direitos, deveres e benefícios, Estratégias de divulgação e captação de alunos, Adequação dos espaços
        e organização dos alunos, Plano de aulas, Lidando com diferentes níveis na mesma aula, Eventos internos e
        externos, Avaliações, relatórios e reuniões com os pais, Encaminhamento dos alunos &nbsp;para células
        receptoras.
    </p>

    <p>
        - Duração: 16 horas<br />
        - Horário: das 08:00 às 18:00 hrs.<br />
        - Avaliação: teórica<br />
        - Pontos no SNGP: 12<br />
        - Valor: R$ 250,00 (filiados) e R$ 270,00&nbsp;(não filiados)
    </p>

    <p>&nbsp;</p>

    <p>
        <strong>Inscrições</strong>: A inscrição é feita através de depósito bancário no Banco Itaú, agência 0740 c/c
        66.927-0, CESAR KIST E CD LTDA ME, CNPJ 08.679.865/0001-38. Após realizar o depósito, enviar o comprovante por
        e-mail para kelly.ferreira@cbtenis.com.br aos cuidados de Kelly Ferreira, com o nome completo, endereço,
        telefones, e-mail e o nome da cidade em qual realizará o curso.
    </p>

    <p>
        <strong>Obs</strong>: O participante poderá se filiar no local do curso, usufruindo imediatamente do desconto. A
        segunda parcela é paga no local com cheque pré-datado.
    </p>

    <p>
        <strong>Atenção</strong>: O Departamento de Capacitação se reserva no direito de adiar o curso até 3 dias antes
        da data, caso não haja o mínimo de 15 inscritos. Nesse caso, todos serão avisados.
    </p>

    <p>&nbsp;</p>

    <div style="margin-top: 20px">
        <p style="margin: 6px 10px 4px 0">Clique abaixo para visualizar o CÓDIGO DE ÉTICA PARA PROFESSORES - ITF</p>
        <a
            href="http://cbt-tenis.com.br/arquivos/capacitacao/capacitacao_58922fd7647bb_01-02-2017_16-58-31.pdf"
            target="_blank"
            class="button"
        >
            Ver PDF</a
        >
    </div>
</div>
